const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionsB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M445.651 201.95c-1.485-9.308-10.235-15.649-19.543-14.164-9.308 1.485-15.649 10.235-14.164 19.543.016.102.033.203.051.304 17.38 102.311-51.47 199.339-153.781 216.719-102.311 17.38-199.339-51.47-216.719-153.781C24.115 168.26 92.966 71.232 195.276 53.852c62.919-10.688 126.962 11.29 170.059 58.361l-45.605 15.19c-8.944 2.976-13.781 12.638-10.806 21.582l.003.007c2.976 8.944 12.638 13.781 21.582 10.806l.007-.002 72.4-24.133a17.068 17.068 0 0 0 11.674-16.196v-72.4c0-9.426-7.641-17.067-17.067-17.067s-17.067 7.641-17.067 17.067v32.344C292.564-4.185 153.545-.702 69.949 87.19s-80.114 226.911 7.779 310.508c87.893 83.597 226.911 80.114 310.508-7.779a219.633 219.633 0 0 0 57.415-187.969Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.0478 0 0 .0478 .048 -.405)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 151c24.813 0 45 20.187 45 45 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-41.355-33.645-75-75-75s-75 33.645-75 75v45h-15c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15h15c-.267 1.404 3.046 35.742-25.606 64.393C145.976 344.81 152.646 361 166 361h150c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15H196.061c16.632-29.578 14.798-58.837 14.939-60h45c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15h-45v-45c0-24.813 20.187-45 45-45Z",
    style: {
      fill: "#727272",
      fillRule: "nonzero"
    },
    transform: "matrix(.03868 0 0 .03868 1.126 2.129)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsB);
export default __webpack_public_path__ + "static/media/transactions-b.d3b959c9785860006211c27d42e13da8.svg";
export { ForwardRef as ReactComponent };